module.exports = __webpack_public_path__ + "static/media/exclamation-circle-fill.8921603a.svg";